export default {
  baseInfo: {
    title: 'Base Info',
  },
  invoice: {
    title: 'Invoice Progress',
    step1: {
      title: 'Apply',
      content: 'The electronic invoice has been submitted on December 21st',
    },
    step2: {
      title: 'Electronic invoice',
      content: 'expected to be processed within 1-3 business days.',
    },
    step3: {
      title: 'Invoice is send',
      content: 'we will contact you within 7 business days.',
    },
    step4: {
      title: 'Finish',
    },
  },
  product: {
    title: 'Product Category',
    add: 'add production',
    month: 'month',
    quarter: 'quarter',
  },
  detail: {
    title: 'Product Procurement Detail',
    form: {
      applyNo: 'Apply no',
      product: 'Name',
      productNo: 'No.',
      department: 'Department',
      num: 'Num',
      createTime: 'Create time',
      operation: 'Operation',
      manage: 'manage',
      delete: 'delete',
    },
  },
};
